import React, { createContext, useContext } from 'react';
const DEFAULT_LOCALE = 'en';
function isValidLocale(lc) {
  return lc === 'en' || lc === 'fi' || lc === 'sv';
}

/**
 * Normalise an input string to a locale identifier
 *
 * @param {string} locale
 * @returns {('en' | 'fi' | 'sv')}<
 */
export function getLocale(locale) {
  if (isValidLocale(locale)) {
    return locale;
  }
  if (locale && typeof locale === 'string') {
    // looks for the canonical primary subtag of a BCP 47 language tag
    const lc = locale.toLowerCase().replace(/[^a-z].*/, '');
    if (isValidLocale(lc)) {
      return lc;
    }
  }
  return DEFAULT_LOCALE;
}
/** @ignore */
export const LocaleContext = /*#__PURE__*/createContext(DEFAULT_LOCALE);

/**
 * Locale context provider, required by many OPUX components.
 *
 * If not provided around a component, it will default to English. Note that
 * not all strings used by a component are visible; some are required for
 * accessibility fetures.
 */
export const LocaleProvider = _ref => {
  let {
    children,
    locale
  } = _ref;
  return /*#__PURE__*/React.createElement(LocaleContext.Provider, {
    value: getLocale(locale)
  }, children);
};
export const useLocale = () => getLocale(useContext(LocaleContext));